var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"breakdown-selector",class:{
    open: _vm.open,
    disabled: _vm.disabled,
    'is-wrapped': _vm.isWrapped,
    'is-loading': _vm.isLoading,
  }},[_c('dropdown-select',{class:{ 'is-wrapped': _vm.isWrapped },attrs:{"multiple":false,"options":_vm.options,"disabled":_vm.disabled || _vm.isLoading,"label-parser":_vm.literal},on:{"open":function($event){_vm.open = true},"close":function($event){_vm.open = false}},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }